import { CancelIcon } from "../../assets/icons/icon-assets";
import { Pressable } from "native-base";
import React, { FC } from "react";

interface Props {
  callback: any | undefined;
  color: string | undefined;
  size: any | undefined;
  disabled?: boolean;
}

const AVCancel: FC<Props> = ({
  callback,
  color,
  size = 35,
  disabled = false,
}) => {
  return (
    <Pressable
      _hover={{
        bgColor: "AVColor.grey",
        rounded: "full",
      }}
      onPress={() => {
        callback(false);
      }}
      zIndex={1}
      disabled={disabled}
      opacity={disabled ? 0.5 : 1}
    >
      <CancelIcon size={"30px"} color={"AVColor.black"} />
    </Pressable>
  );
};

export default AVCancel;
